if (!customElements.get('search-form')) {
  class ComponentSearch extends HTMLElement {
    constructor() {
      super();
      this.searchField = this.querySelector('input[name="q"]');
      this.results = this.querySelector('.search-results');
      this.form = this.querySelector('form');
      this.searchDelay = 300;
      this.searchType = this.querySelector('input[name="type"]').value || 'product';
      this.controller = null;
      this.requestTimeout = 0;
      this.predictiveSearch = this.dataset.predictiveSearch=='true';
      this.wildcard = this.dataset.wildcard=='true' ? '*' : '';
      this.showPrice = this.dataset.showPrice=='true';
      this.predictiveShowProducts = this.dataset.predictiveShowProducts !== 'false';
      this.predictiveShowCollections = this.dataset.predictiveShowCollections === 'true';
      this.predictiveShowPages = this.dataset.predictiveShowPages === 'true';
      this.predictiveShowArticles = this.dataset.predictiveShowArticles === 'true';

      if (this.dataset.autocomplete == "true") {
        this.documentClickHandler = this.documentClick.bind(this);
        this.searchField.addEventListener('input', this.doSearch.bind(this));
        this.searchField.addEventListener('focus', ()=> {
          if (!this.resultsVisible) {
            this.searchField.dispatchEvent(new CustomEvent('input'));
          }
        });
      }

      this.form.addEventListener('submit', (e)=>{
        e.preventDefault();
        const formData = new FormData(this.form);
        const searchParams = new URLSearchParams(formData);
        const query = searchParams.get('q');
        this.saveSearchTerm(query);
        if(query && query!="") {
          searchParams.set('q', this.wildcard + query + this.wildcard);
          location = this.form.action + '?' + searchParams.toString();
        }
      });
    }

    saveSearchTerm(query) {
      
      try {
        query = query.trim();
        var typeParam = this.form.querySelector('[name="type"]').value;
        if (typeParam.indexOf('product') > -1) {
          var lastTerms = this.getLastSearchTerms();
          if (lastTerms.indexOf(query) == -1) {
            lastTerms.splice(0,0,query);
            lastTerms = lastTerms.slice(0, 5);
            sessionStorage.setItem('last_search_terms', lastTerms.join(','));
          }
        }
      } catch (e) {
        console.warn(e);
      }
      
    }

    getLastSearchTerms() {
      var lastTerms = [];
      
      try {
        lastTerms = (sessionStorage.getItem('last_search_terms') || '').split(',').map(x=>x.trim()).filter(x=>x!='');
      } catch (e) {
        console.warn(e);
      }
      
      return lastTerms;
    }

    getPredictiveResourceTypes() {
      var types = [];
      if (this.predictiveShowProducts) {
        types.push('product');
      }
      if (this.predictiveShowCollections) {
        types.push('collection');
      }
      if (this.predictiveShowPages) {
        types.push('page');
      }
      if (this.predictiveShowArticles) {
        types.push('article');
      }
      return types.length ? types.join(',') : 'product';
    }

    getSeeAllSearchType() {
      if (this.predictiveSearch) {
        return this.getPredictiveResourceTypes();
      }
      return this.searchType;
    }

    hasVisiblePredictiveResults(response) {
      if (this.predictiveShowProducts && response.results.length > 0) {
        return true;
      }
      if (this.predictiveShowCollections && response.collections && response.collections.length > 0) {
        return true;
      }
      if (this.predictiveShowArticles && response.articles.length > 0) {
        return true;
      }
      if (this.predictiveShowPages && response.pages.length > 0) {
        return true;
      }
      return false;
    }

    //term param allows to trigger custom search from js code.
    doSearch(term) {
      var standardSearchTerm = typeof(term)=="string" ? term : this.wildcard + this.searchField.value.trim() + this.wildcard;
      if (this.predictiveSearch)
        term = typeof(term)=="string" ? term : this.searchField.value.trim();
      else 
        term = standardSearchTerm;
      if (this.controller) {
        this.controller.abort();
        this.controller = null;
      }
      clearTimeout(this.requestTimeout);
      if (standardSearchTerm.length>=3) {
        this.showSearchingResults();
        this.requestTimeout = setTimeout(()=>{
          this.controller = new AbortController();
          var searchSectionId = this.predictiveSearch ? 'search_predictive_json' : 'search_standard_json';
          var resourceTypes = this.predictiveSearch ? this.getPredictiveResourceTypes() : this.searchType;
          var searchUrl = this.predictiveSearch
            ? (window.PredictiveSearchShared
              ? PredictiveSearchShared.buildSuggestUrl(term, searchSectionId, resourceTypes)
              : routes.predictive_search_url +
                '?resources[type]=' + encodeURIComponent(resourceTypes) +
                '&q=' + encodeURIComponent(term) +
                '&resources[limit]=10' +
                '&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku' +
                '&section_id=' + encodeURIComponent(searchSectionId))
            : routes.search_url + '?section_id=' + searchSectionId + '&type=' + this.searchType + '&q=' + encodeURIComponent(term);
          $s.get({
            signal: this.controller.signal,
            url: searchUrl,
            success: (data)=>{
              if (!this.resultsVisible) {
                return;
              }
              var parser = new DOMParser();
              var doc = parser.parseFromString(data, "text/html");
              var response = JSON.parse(doc.querySelector('div').innerHTML);
              this.clearResults(false);

              var hasResults = this.predictiveSearch
                ? this.hasVisiblePredictiveResults(response)
                : (response.results_count > 0 || (response.collections && response.collections.length > 0));

              if (!hasResults) {
                this.noResults();
                return;
              }

              var title = document.createElement('div');
              title.innerHTML = lngg.search_js__search_results_caption;
              title.classList.add('visually-hidden');
              this.results.appendChild(title);
              var items = document.createElement('div');
              items.classList.add('search-results-items');
              this.results.appendChild(items);

              var categories = 0;
              var showProducts = !this.predictiveSearch || this.predictiveShowProducts;
              var showCollections = !this.predictiveSearch || this.predictiveShowCollections;
              var showArticles = !this.predictiveSearch || this.predictiveShowArticles;
              var showPages = !this.predictiveSearch || this.predictiveShowPages;

              if (showProducts && response.results.length > 0) {
                categories++;
              }
              if (showCollections && response.collections && response.collections.length > 0) {
                categories++;
              }
              if (showArticles && response.articles.length > 0) {
                categories++;
              }
              if (showPages && response.pages.length > 0) {
                categories++;
              }

              if (showProducts && response.results.length > 0) {
                if (categories == 1) {
                  response.results = response.results.slice(0, 5);
                }
                this.buildCategory(items, 'product', lngg.search_js__products_title, response.results);
              }
              if (showCollections && response.collections && response.collections.length > 0) {
                if (categories == 1) {
                  response.collections = response.collections.slice(0, 5);
                }
                this.buildCategory(items, 'collections', lngg.search_js__collections_title, response.collections || []);
              }
              if (showArticles && response.articles.length > 0) {
                if (categories == 1) {
                  response.articles = response.articles.slice(0, 5);
                }
                this.buildCategory(items, 'article', lngg.search_js__articles_title, response.articles);
              }
              if (showPages && response.pages.length > 0) {
                if (categories == 1) {
                  response.pages = response.pages.slice(0, 5);
                }
                this.buildCategory(items, 'page', lngg.search_js__pages_title, response.pages);
              }

              if (categories > 1) {
                items.classList.add('multi-category');
              }

              var displayedCount = 0;
              if (showProducts) {
                displayedCount += response.results.length;
              }
              if (showArticles) {
                displayedCount += response.articles.length;
              }
              if (showPages) {
                displayedCount += response.pages.length;
              }

              if (showProducts && response.results_count > displayedCount) {
                var linkUrl = routes.search_url + '?type=' + this.getSeeAllSearchType() + '&q=' + encodeURIComponent(standardSearchTerm);
                this.results.appendChild(this.buildSeeAllLink(linkUrl, response.results_count));
              }

              if (window.LinkPrefetch && window.LinkPrefetch.addHoverListener) {
                window.LinkPrefetch.addHoverListener(this.results);
              }
            }
          });
        }, this.searchDelay);
      } else {
        this.suggestedResults();
      }
    }

    buildItem(itemJson) {
      var info = document.createElement('div');
      var title = document.createElement('div');
      var a = document.createElement('a');
      a.classList.add("result-item", "flex", "direction-row", "justify-content-start", "align-items-start");
      a.href = itemJson.url;
      // Eraya price test: lets the SDK match this result to its product/variant.
      if (itemJson.id) a.dataset.productId = itemJson.id;
      if (itemJson.variant_id) a.dataset.variantId = itemJson.variant_id;
      if (typeof(itemJson.thumbnail)!='undefined') {
        var img = document.createElement('img');
        img.src = itemJson.thumbnail ? itemJson.thumbnail : '';
        img.alt = '';
        a.appendChild(img);
      }

      title.classList.add('title');
      title.textContent = itemJson.title || '';
      a.appendChild(info);
      info.appendChild(title);
      info.classList.add('info');
      if (this.showPrice && itemJson.price != undefined) {
        var price = document.createElement('div');
        price.classList.add('price', 'money');
        var hasRange = itemJson.price_min != null
          && itemJson.price_max != null
          && Number(itemJson.price_min) > 0
          && Number(itemJson.price_max) > Number(itemJson.price_min);
        if (hasRange) {
          var minPrice = $s.formatMoney(itemJson.price_min).replace('.00', '');
          var maxPrice = $s.formatMoney(itemJson.price_max).replace('.00', '');
          var srText = (lngg.product__price_between_label || 'Price between  and ')
            .replace('', minPrice)
            .replace('', maxPrice);
          price.innerHTML = '<span class="visually-hidden">' + srText + ': </span><span aria-hidden="true">' + minPrice + ' - ' + maxPrice + '</span>';
        } else {
          price.innerHTML = $s.formatMoney(itemJson.price).replace('.00', '');
        }
        info.appendChild(price);
      }
      return a;
    }

    buildCategory(container, type, categoryTitle, results) {
      var group = document.createElement('div');
      group.classList.add('search-results-'+type, 'search-results-group');
      var title = document.createElement('div');
      container.appendChild(title);
      title.outerHTML = '<div class="result-group-title-wrapper"><div class="result-group-title small-label">'+categoryTitle+'</div></div>'
      container.appendChild(group);
      results.forEach((item)=>{
        group.appendChild(this.buildItem(item));
      });
    }

    buildSeeAllLink(url, resultsQuantity) {
      var a = document.createElement('a');
      a.classList.add('btn');
      a.href = url;
      a.innerHTML = lngg.search_js__see_all_n_results_link.replace(new RegExp(/{{ *quantity *}}/), resultsQuantity);
      return a;
    }

    showSearchingResults() {
      this.resultsVisible = true;
      if (!this.results.style.minHeight) {
        document.addEventListener('click', this.documentClickHandler);

        var height = this.results.offsetHeight;
        this.results.style.minHeight = Math.max(height, 80)  + 'px';
        this.results.innerHTML = '<div class="loader-wrap flex justify-content-center align-items-center"><div class="loader"></div></div>';
      }
    }

    clearResults(removeEvents=true) {
      if(removeEvents) {
        document.removeEventListener('click', this.documentClickHandler);
        this.resultsVisible = false;
      }
      this.results.innerHTML = '';
      this.results.style.minHeight = '';
    }

    noResults() {
      this.suggestedResults();
      this.results.innerHTML = '<div class="no-results">' + lngg.search_js__no_products_found_message + '</div>' + this.results.innerHTML;
    }

    suggestedResults() {
      this.clearResults();
      var popularTerms = [].map(x=>x.trim()).filter(x=>x!='');
      var typeParam = this.form.querySelector('[name="type"]').value;
      var lastTerms = this.getLastSearchTerms();
      var popularSearches = this.dataset.popularSearches ? JSON.parse(this.dataset.popularSearches) : [];
      var html = `<div class="suggested-results" ${popularSearches.length==0 && popularTerms.length==0 && lastTerms.length==0 ? 'style="display: none;"' : ''}>
        <div class="grid">
          <div class="grid-item flex-1" ${popularSearches.length==0 ? 'style="display: none;"' : ''}>
            <div class="title heading-font">${lngg.search_js__popular_searches_title}</div>
            <ul>`;
      for (var i=0; i<popularSearches.length; i++) {
        html += `<li class="suggested-item"><a href="${popularSearches[i].url}">${popularSearches[i].title}</a></li>`;
      }

      html += `</ul>
          </div>
          <div class="grid-item flex-1" ${popularTerms.length==0 ? 'style="display: none;"' : ''}>
            <div class="title heading-font">${lngg.search_js__popular_search_terms_title}</div>
            <ul>`;
      for (var i=0; i<popularTerms.length; i++) {
        html += `<li class="suggested-item"><a href="${routes.search_url}?type=${typeParam}&q=${this.wildcard}${encodeURIComponent(popularTerms[i])}${this.wildcard}">${popularTerms[i]}</a></li>`;
      }

      html += `</ul>
          </div>
          <div class="grid-item flex-1" ${lastTerms.length==0 ? 'style="display: none;"' : ''}>
            <div class="title heading-font">${lngg.search_js__your_last_searches_title}</div>
            <ul>`;
      for (var i=0; i<lastTerms.length; i++) {
        html += `<li class="suggested-item"><a href="${routes.search_url}?type=${typeParam}&q=${this.wildcard}${encodeURIComponent(lastTerms[i])}${this.wildcard}">${lastTerms[i]}</a></li>`;
      }
        
      html += `</ul>
          </div>
        </div>
      </div>`;
      
      if(popularSearches.length !==0 || popularTerms.length !==0 || lastTerms.length !==0){
        this.results.innerHTML = html;
      }

      document.addEventListener('click', this.documentClickHandler);
    }

    documentClick(e) {
      if(!this.contains(e.target)) {
        this.clearResults();
      }
    }
  }
  customElements.define('search-form', ComponentSearch);
}